const initState = {
  adtarget: null // 定向包数据
}
const state = {
  ...initState,
  initState() {
    return initState
  }
}
const mutations = {
  // 获取定向包数据
  getAdtarget(state, data) {
    state.adtarget = data
    console.log(state.adtarget, '我是adtarget')
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
// selectExistDirectionPackage
